import { Swiper } from "swiper/react";

const DiscoverAlbumSkeleton = () => {
  const arr = [1, 2, 3, 4, 5, 6, 7];
  return (
    <div>
      <div className="">
        <Swiper
          slidesPerView={7}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            370: {
              slidesPerView: 2,
            },
            700: {
              slidesPerView: 3,
            },
            1000: {
              slidesPerView: 4,
            },
            1200: {
              slidesPerView: 5,
            },
            1400: {
              slidesPerView: 6,
            },
            1600: {
              slidesPerView: 7,
            },
          }}
          className="mt-4 mb-5 mySwiper"
        >
          <div className="flex flex-row lg:gap-[20px] sm:gap-[20px]">
            {arr.map((item: any) => (
              <div key={item} className="flex flex-col items-start justify-center">
                <div className="lg:w-[170px] h-[250px] w-[170px] bg-[#1a1919] animate-pulse mt-2"></div>
              </div>
            ))}
          </div>
        </Swiper>
      </div>
    </div>
  );
};

export default DiscoverAlbumSkeleton;
